<template>
  <div>
    <div class="EventRecords Content">
      <div class="Content-group">
        <div :class="[{'is-loading': ui.isLoading && !event.id},'Section']">
          <div
            v-if="event.id"
            class="u-flex u-flex-wrap"
          >
            <div class="EventActionButtons">
              <router-link
                class="Button Button--Blue"
                tag="button"
                :disabled="event.is_locked"
                :to="{name: editEventLink, params:{ id: event.id }}"
              >
                <span class="Icon Icon-pencil" />  Edit Event
              </router-link>

              <button
                :disabled="hasNoEmbedLinks"
                class="Button Button--Blue"
                @click="ui.showEmbedModal = true"
              >
                Web Form
              </button>
              <button
                id="ExportRecordsButton"
                :class="{'is-loading': ui.exportButtonIsLoading}"
                class="Button Button--Blue"
                @click="ui.showExportModal = true"
              >
                <span class="Icon Icon-cloud-download" /> Export
              </button>
              <router-link
                tag="button"
                :disabled="event.is_locked"
                :to="{ name: 'automations' , params:{ id: event.id } }"
                class="Button Button--Blue"
              >
                Automations
              </router-link>
              <router-link
                v-if="event.can_access_integrations"
                tag="button"
                :disabled="event.is_locked"
                :to="{ name: 'event-integrations' , params:{ id: event.id } }"
                class="Button Button--Blue"
              >
                Integrations
              </router-link>
              <export-records-modal
                v-model="ui.showExportModal"
                :event-id="event.id"
                :event-questions="event.questions"
              />
              <embed-form-modal
                v-model="ui.showEmbedModal"
                :event="event"
              />
            </div>
            <div
              v-if="event.id"
              class="TableFilters"
            >
              <div class="Input-container">
                <span class="Label">Filter</span>
                <date-range-picker
                  ref="picker"
                  v-model="dateRanges"
                  :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
                  :auto-apply="true"
                  class="DateRangePicker"
                  @update="handleDatesUpdate"
                />
                <span
                  v-if="dateRanges.startDate"
                  class="ClearButton Icon Icon-times"
                  @click="handleDatesUpdate(null)"
                />
              </div>

              <rmp-input
                v-model="searchQuery"
                class="RecordsSearch"
                :clearable="true"
                input-type="text"
                placeholder="Search by Name or Email"
                @keypress.enter="handleSearch"
                @cleared="handleSearch"
              />
            </div>
          </div>
        </div>
        <div class="Section">
          <event-records-datatable
            v-if="event.id"
            ref="eventRecordsDatatable"
            :key="event.id"
            :event-is-locked="event.is_locked"
            :event-id="event.id"
            @event-records-data-table:embed-form="ui.showEmbedModal = true"
          />
        </div>
      </div>
      <div>
        <router-link
          v-if="event"
          :to="{ name: 'events-index'}"
          class="BackButton Button Button--green-outline"
        >
          Back
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DateRangePicker from 'vue2-daterange-picker';
import RmpInput from '@rmpenterprise/form-input';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import EmbedFormModal from '../modals/embed-form';
import ExportRecordsModal from '../modals/export-records';
import EventRecordsDatatable from '../data-tables/event-records-data-table.vue';

export default {
  components: {
    EventRecordsDatatable,
    ExportRecordsModal,
    DateRangePicker,
    EmbedFormModal,
    RmpInput,
  },
  data() {
    return {
      searchQuery: null,
      dateRanges: {
        start: '01/01/2020',
        end: '01/01/2100',
      },
      ui: {
        isLoading: false,
        showExportModal: false,
        showEmbedModal: false,
        exportButtonIsLoading: false,
      },
    };
  },
  computed: {
    ...mapState('events', {
      event: (state) => state.event,
    }),
    hasNoEmbedLinks() {
      if (this.event.embedded_code_generation_default_url !== undefined) { return this.event.embedded_code_generation_default_url === null && this.event.embedded_code_script_source === null; }
      return null;
    },
    editEventLink() {
      if (this.event.type === 'dynamic') return 'basic-info-dynamic-form';
      return 'basic-info';
    },
  },
  methods: {
    handleDatesUpdate(ev) {
      if (ev === null) {
        this.resetDatesFilter();
        return;
      }

      const { endDate, startDate } = ev;

      // Convert to JSON format and split the date arrays to desired format (dd-mm-yyyy)
      const formattedStartDate = startDate
        .toJSON()
        .split('T')[0]
        .split('-')
        .reverse()
        .join('-');
      const formattedEndDate = endDate
        .toJSON()
        .split('T')[0]
        .split('-')
        .reverse()
        .join('-');

      this.$refs.eventRecordsDatatable.additionalParams.registeredFrom = `${formattedStartDate}`;
      this.$refs.eventRecordsDatatable.additionalParams.registeredTo = `${formattedEndDate}`;
      this.$refs.eventRecordsDatatable.submitSearch();
    },
    handleSearch() {
      // Communication between parent and child component through refs
      this.$refs.eventRecordsDatatable.additionalParams.search = this.searchQuery;
      this.$refs.eventRecordsDatatable.submitSearch();
    },
    resetDatesFilter() {
      delete this.$refs.eventRecordsDatatable.additionalParams.registeredTo;
      delete this.$refs.eventRecordsDatatable.additionalParams.registeredFrom;

      this.dateRanges.startDate = null;
      this.dateRanges.endDate = null;
      this.$refs.eventRecordsDatatable.submitSearch();
    },
  },
};
</script>

<style lang="less" scoped>
.Section {
  border: none;
}

.BackButton{
  margin-top: 10px;
}

.EventActionButtons {
  flex-grow: 1;
  flex-shrink: 0;
  margin-bottom: 10px;
}
.TableFilters {
  top: -103px;
  right: 0;
  display: flex;

  .Input-container {
    display: flex;
    width: 300px;
    align-items: baseline;
    position: relative;

    .Label {
      margin-right: 10px;
    }

    .ClearButton {
      position: absolute;
      cursor: pointer;
      top: 13px;
      right: 47px;
    }
  }

  .RecordsSearch {
    width: 250px;
  }
}
</style>
